import { Location } from './location.model';
import { SessionDates } from './session-dates.model';

/**
 * Docebo Sessions model
 */
export class Sessions {
  constructor(
    public idSession: number,
    public name: string,
    public description: string,
    public startDate: Date,
    public endDate: Date,
    public maxEnroll: number,
    public countEnrolled: string, // NOTE: Docebo has this as default as string not as number
    public dates: SessionDates[],
    public locations: Location[],
    public lastSubscriptionDate: Date,
    public sessionSelected: boolean = false, // Not currently used
    public sessionDeliveryType?: string,
    public canEnroll?: boolean,
    public sessionEnrollErrorMessage?: string
  ) {}
}
